import { Material } from "three";

import { ElementTypeEnum } from "../elementTypeMappings"
import { defaultMaterial } from "../utils/defaultMaterial";

interface IMaterialSet {
    getMaterial(elementType: ElementTypeEnum, representationType: string): Material;
    getMappings(): IMaterialMapping[];
}

interface IMaterialMapping {
    ElementType: ElementTypeEnum;
    RepresentationType?: string; // Can be 2d or 3d
    Material: Material;
}

class MaterialSet implements IMaterialSet {

    private materialMappings: IMaterialMapping[] = [];

    constructor(materials: IMaterialMapping[]) {
        this.materialMappings = materials;
    }

    getMappings(): IMaterialMapping[] {
        return this.materialMappings;
    }

    getMaterial(elementType: ElementTypeEnum, representationType: string): Material {

        // Try to find exact match
        let mapping = this.materialMappings.find(m => m.ElementType === elementType && m.RepresentationType === representationType);

        // Fallback to first mapping with matching ElementType
        if (!mapping) {
            mapping = this.materialMappings.find(m => m.ElementType === elementType);
        }

        // We are not leaving without material ;)
        if (!mapping) {
            console.warn(`No material mapping found for ElementType: ${elementType} and RepresentationType: ${representationType}`);
            return defaultMaterial;
        }
        
        return mapping.Material;
    }

};

export { IMaterialSet, IMaterialMapping, MaterialSet };